export type EngagementSubjectType = 'announcement' | 'finish_line' | 'checkpoint' | 'gate'
export type EngagementStatus = 'seen' | 'dismissed'

export interface UserEngagementArgument {
  id?: string
  userID: string
  subjectType: EngagementSubjectType | string
  subjectID: string
  status?: EngagementStatus
  createdAt?: Date
}

export default class UserEngagement {
  readonly id?: string
  readonly userID: string
  readonly subjectType: string
  readonly subjectID: string
  readonly status: EngagementStatus
  readonly createdAt: Date

  constructor(arg: UserEngagementArgument) {
    this.id = arg.id
    this.userID = arg.userID
    this.subjectType = arg.subjectType
    this.subjectID = arg.subjectID
    this.status = arg.status ?? 'seen'
    this.createdAt = arg.createdAt ?? new Date()
  }

  static create(userID: string, subjectType: string, subjectID: string): UserEngagement {
    return new UserEngagement({ userID, subjectType, subjectID })
  }

  static fromPG(row: any): UserEngagement {
    return new UserEngagement({
      id: row.id,
      userID: row.user_id,
      subjectType: row.subject_type,
      subjectID: row.subject_id,
      status: row.status ?? 'seen',
      createdAt: new Date(row.created_at),
    })
  }

  toPG(): Record<string, unknown> {
    return {
      user_id: this.userID,
      subject_type: this.subjectType,
      subject_id: this.subjectID,
      status: this.status,
      created_at: this.createdAt.toISOString(),
    }
  }
}
